import { render, staticRenderFns } from "./r-currency-correction-dialog.vue?vue&type=template&id=28200a6e&scoped=true"
import script from "./r-currency-correction-dialog.vue?vue&type=script&lang=js"
export * from "./r-currency-correction-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-currency-correction-dialog.vue?vue&type=style&index=0&id=28200a6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28200a6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28200a6e')) {
      api.createRecord('28200a6e', component.options)
    } else {
      api.reload('28200a6e', component.options)
    }
    module.hot.accept("./r-currency-correction-dialog.vue?vue&type=template&id=28200a6e&scoped=true", function () {
      api.rerender('28200a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-correction-dialog.vue"
export default component.exports